import type {ReactElement} from 'react';
import type {GRID_ITEM_TYPE, GridItemBaseStorage, GridItemProps} from '@Components/base-grid/components/grid-item';
import {GridItem} from '@Components/base-grid/components/grid-item';
import type {ButtonPropsWithout} from '@Components/button';
import {Button, ButtonSize} from '@Components/button';

export interface GridGenericButtonItemStorage extends GridItemBaseStorage {
  buttonProps: ButtonPropsWithout<'children'>;
  width?: number;
  height?: number;
  type: GRID_ITEM_TYPE.GENERIC_BUTTON;
}

interface GridGenericButtonItemProps extends GridItemProps {
  buttonProps: ButtonPropsWithout<'children'>;
  width?: number;
  height?: number;
}

export function GridGenericButtonItem({...props}: GridGenericButtonItemProps): ReactElement<any> {
  return (
    <GridItem {...props} onClicked={props.onClicked} className={`flex-center grid-item ${props.containerClassName ?? ''}`} showHoverOverlay={false}>
      <Button size={ButtonSize.LARGE} {...props.buttonProps} />
    </GridItem>
  );
}
